export const NUMBER_REGEX = /[0-9]/;
export const MAX_PAGINATION_TAKE_SIZE = 1000000000;
export const SEARCH_DEBOUNCE_DELAY = 333;
